"use strict";

import angular from "angular";

import template from "./menu.html";
import "./menu.scss";

const name = "nuMenu";
const def = {
    bindings: {
        items: "=",
        extraParams: "=",
        isDisabled: "="
    },
    controllerAs: "menuCtrl",
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
